import { Logo } from '../components/Logo'
import styled from 'styled-components';
import { Aco } from '../components/Aco';

const data = [
  {en: "Prenyl acetate", value: "0.36%"},
  {en: "Alpha-pinene", value: "0.28%"},
  {en: "Beta-pinene", value: "0.1%"},
  {en: "Myrcene", value: "0.17%"},
  {en: "p-methyl anisole", value: "6.81%"},
  {en: "limonene", value: "0.05%"},
  {en: "1,8-cineole", value: "0.43%"},
  {en: "Mythyl benzoate", value: "3.25%"},
  {en: "Linalool", value: "13.96%"},
  {en: "Benzyl acetate", value: "3.12%"},
  {en: "Alpha-terpineol", value: "0.17%"},
  {en: "Geraniol", value: "2.12%"},
  {en: "Geranial", value: "0.09%"},
  {en: "Neryl acetate", value: "0.79%"},
  {en: "Alpha-copaene", value: "0.86%"},
  {en: "Geranyl acetate", value: "9.95%"},
  {en: "Beta-elemene", value: "0.49%"},
  {en: "Beta-caryophyllene", value: "12.7%"},
  {en: "Trans-cinnamyl acetate", value: "0.65%"},
  {en: "Alpha-humulene", value: "4.1%"},
  {en: "Gamma-muurolene", value: "1.42%"},
  {en: "Germacrene D", value: "8.82%"},
  {en: "Cis-gamma-bisabolene", value: "1.82%"},
  {en: "(E,E)-alpha-farnesene", value: "5.83%"},
  {en: "Gamma-cadinene", value: "0.8%"},
  {en: "Delta-cadinene", value: "2.98%"},
  {en: "Epi-alpha-cadinol", value: "1.12%"},
  {en: "Alpha-cadinol", value: "1.49%"},
  {en: "(E,E)—farnesol", value: "1.36%"},
  {en: "Benzyl benzoate", value: "5.43%"},
  {en: "(E,E)-farnesyl acetate", value: "1.05%"},
  {en: "Benzyl salicylate", value: "1.17%"},
]

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`

const LeftLayout = styled.div`
  float: left;
  padding: 0 0 40px 0;
  @media screen and (min-width:960px) {
    width: 545px;
  }
`

const RightLayout = styled(LeftLayout)`
  @media screen and (min-width:960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`

const NumberData = styled.td`
  text-align: right;
`

const detail = [
  {title: '使用期限', value: new Date('2025-06-30T00:00:00.000+0300').toLocaleDateString()},
  {title: '原産国', value: 'マダガスカル'},
  {title: '抽出部位', value: '花'},
  {title: '抽出方法', value: '水蒸気蒸留法'},
  {title: '学名', value: 'Cananga odorata'},
]

export const YlangYlang = () => <Layout>
<LogLayout><Logo /></LogLayout>
<LeftLayout>
<table>
  <tbody>
    {detail.map((item, index) => <tr key={index}>
      <th>{item.title}</th><td>{item.value}</td>
    </tr>)}
  </tbody>
</table>
<h2>Certification of analysis</h2>
<h3>1. PRODUCT IDENTIFICATION AND COMPOSITION </h3>
<ul>
  <li>1.1 Product Name: Ylang Ylang 1st Oil 100% Organic ACO </li>
  <li>1.2 Botanical Name: Cananga odorata TEST SPECIFICATION RESULT </li>
</ul>
<h3>2. PHYSICAL AND CHEMICAL PROPERTIES </h3>
<ul>
  <li>2.1 Appearance: Clear, pale yellow to yellow-amber liquid </li>
  <li>2.2 Odour: Characteristic, intensely sweet, rich, slightly spicy, balsamic-floral, rich creamy background and Jasmin-like overtones </li>
  <li>2.3 Specific Gravity: 0.9200 to 0.97500 @ 20°C Conforms </li>
  <li>2.4 Refractive Index: 1.4900 to 1.5200 @ 20°C Conforms </li>
</ul>
<p>CONSTITUENT SPECIFICATION RESULT</p>
<h3>3. GAS CHROMATOGRAPH ANALYSIS Results</h3>
<table>
  <tbody>
    {data.map((item, index) => <tr key={index}>
      <th>{item.en}</th><NumberData>{item.value}</NumberData>
    </tr>)}
  </tbody>
</table>
</LeftLayout>
<RightLayout>
  <Aco />
</RightLayout>
</Layout>




